import { ReactComponent as EditIcon } from './svgs/icon_edit.svg';
import { ReactComponent as DeleteIcon } from './svgs/icon_delete.svg';
import { ReactComponent as CaretDown } from './svgs/icon_caret_down.svg';
import { ReactComponent as CaretUp } from './svgs/icon_caret_up.svg';
import { ReactComponent as CloseX } from './svgs/icon_close_x.svg';
import { ReactComponent as Check } from './svgs/icon_check.svg';

export const icons = {
  edit: EditIcon,
  delete: DeleteIcon,
  'caret-down': CaretDown,
  'caret-up': CaretUp,
  'close-x': CloseX,
  check: Check,
};
